import { render, staticRenderFns } from "./V1EmptyState.vue?vue&type=template&id=7ef973b1&scoped=true"
import script from "./V1EmptyState.vue?vue&type=script&setup=true&lang=ts"
export * from "./V1EmptyState.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./V1EmptyState.vue?vue&type=style&index=0&id=7ef973b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef973b1",
  null
  
)

export default component.exports